/**
 * Whether null or undefined
 * @param {*} value
 * @returns  {boolean}
 */
export default function isNullOrUndefined(value) {
  return value === null || value === undefined;
}